import { use_slice_ui } from '@/hooks/store/use_slices';
import i18n_page_search from '@/locales/keys/i18n_page_search.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { useTranslation } from 'react-i18next';
import { TopbarInfoWrapper } from '../_base/TopbarInfoWrapper';
import { SButtonHideUnusedSearches } from './_buttons/SButtonHideUnusedSearches';
import { SButtonShowSearchHistory } from './_buttons/SButtonShowSearchHistory';
import { SButtonStartNewSearch } from './_buttons/SButtonStartNewSearch';
import { SDiffusionModelBar } from './diffusion_model/SDiffusionModelBar';
import { SOrientationBar } from './orientation/SOrientationBar';
import { SPromptBar } from './prompt/SPromptBar';
import { SPromptBarHeader } from './prompt/SPromptBarHeader';
import { SScopeDropdown } from './scope/SScopeDropdown';
import { SSearchHistoryList } from './search_history/SSearchHistoryList';

export function SidebarSearch() {
  const { page_search_show_history } = use_slice_ui(['page_search_show_history']);
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SEARCH);

  function render_content() {
    let out = <></>;

    if (page_search_show_history) {
      out = <SSearchHistoryList />;
    } else {
      out = (
        <>
          <div className={`flex flex-col  ${md('bg-component px-0', ' px-2 pt-2')} gap-1 bg-bar`}>
            <SScopeDropdown />
            <SOrientationBar />
            <SDiffusionModelBar />
            <SPromptBarHeader />
          </div>
          <SPromptBar />
        </>
      );
    }

    return out;
  }

  return (
    <div className={`w-full flex flex-col   h-full  ${md(' bg-component gap-1.5', ' bg-component')} `}>
      <div className="flex flex-col">
        <TopbarInfoWrapper>
          <span className="w-full text-center">{t(i18n_page_search.sidebar.title)}</span>
        </TopbarInfoWrapper>

        <div className={`flex w-full gap-1 bg-bar py-1  ${md('bg-component px-0', ' px-2')}`}>
          <SButtonStartNewSearch />
          <SButtonShowSearchHistory />
          <SButtonHideUnusedSearches />
        </div>
      </div>

      <div className={`${md('bg-component', '')} flex flex-col overflow-hidden h-full `}>{render_content()}</div>
    </div>
  );
}
